import { usePathname } from 'next/navigation';

export const useMyClassRoute = () => {
  const pathName = usePathname();

  return { isMyClassRoute: pathName.includes('/my-classes'), pathName };
};
